import { render, staticRenderFns } from "./marquees.vue?vue&type=template&id=c929bf68&scoped=true"
import script from "./marquees.vue?vue&type=script&lang=js"
export * from "./marquees.vue?vue&type=script&lang=js"
import style0 from "./marquees.vue?vue&type=style&index=0&id=c929bf68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c929bf68",
  null
  
)

export default component.exports